import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  GetTerms200,
  GetTerms400,
  GetTerms500,
  GetTermsParams
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 결제 서비스 이용약관을 조회합니다.

**지원하는 약관 타입:**
- electronicFinancialTransactions: 전자금융거래 약관
- collectPersonalInfo: 개인정보 수집·이용 약관
- sharingPersonalInformation: 개인정보 제3자 제공 약관
- telecommunicationCharging: 통신과금 서비스 약관

**사용 예시:**
- 전체 약관 조회: `GET /api/v1/terms`
- 특정 약관 조회: `GET /api/v1/terms?termsType=electronicFinancialTransactions`

 * @summary 약관 조회
 */
export const getTerms = (
    params?: GetTermsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetTerms200>(
      {url: `/api/v1/terms`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetTermsQueryKey = (params?: GetTermsParams,) => {
    return [`/api/v1/terms`, ...(params ? [params]: [])] as const;
    }

    
export const getGetTermsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getTerms>>, TError = GetTerms400 | GetTerms500>(params?: GetTermsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTerms>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTermsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTerms>>> = ({ signal }) => getTerms(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTerms>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTermsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getTerms>>>
export type GetTermsInfiniteQueryError = GetTerms400 | GetTerms500

/**
 * @summary 약관 조회
 */
export const useGetTermsInfinite = <TData = Awaited<ReturnType<typeof getTerms>>, TError = GetTerms400 | GetTerms500>(
 params?: GetTermsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTerms>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTermsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetTermsQueryOptions = <TData = Awaited<ReturnType<typeof getTerms>>, TError = GetTerms400 | GetTerms500>(params?: GetTermsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTerms>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTermsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTerms>>> = ({ signal }) => getTerms(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTerms>>, TError, TData> & { queryKey: QueryKey }
}

export type GetTermsQueryResult = NonNullable<Awaited<ReturnType<typeof getTerms>>>
export type GetTermsQueryError = GetTerms400 | GetTerms500

/**
 * @summary 약관 조회
 */
export const useGetTerms = <TData = Awaited<ReturnType<typeof getTerms>>, TError = GetTerms400 | GetTerms500>(
 params?: GetTermsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTerms>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetTermsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



